import { CompanyResult, SearchWordResult } from "models/StatisticsReport";
import Table from "../Components/Table";
import { useEffect } from "react";

interface SearchWordProps {
    data: SearchWordResult[],
    company:CompanyResult
}

const SearchWord = ({data, company}:SearchWordProps) => {

    const totalCount = new Intl.NumberFormat('nb-NO').format(data.reduce((total, item) => total + item.value, 0));

    useEffect(() => {
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        tooltipTriggerList.forEach((el) => {
            new (window as any).bootstrap.Tooltip(el);
        });
    }, []);

    return (
        <div className="card mb-4">
            <div className="card-header">
                <div className="d-flex align-items-center">
                    <h2 className="p2"><big className="fw-bold">{totalCount}</big> søk med treff i din bedrifts søkeord</h2>
                </div>
            </div>
            <div className="card-body">
                <Table useSlice={true} data={data} limit={10} columnName={["Søkeord","Antall treff"]} />
                {/* <p className="text-muted mb-0 mt-3">
                    <small>
                        <button type="button" data-bs-toggle="tooltip" data-bs-title="Bransjesøkeord er 1881s egne søkeord som peker til bransjer ved søk etter disse ordene" className="link-secondary btn btn-link p-0">
                            <u>Bransjesøkeord</u>
                        </button> er uthevet.
                    </small>
                </p> */}
            </div> 
        </div>
    );
}

export default SearchWord;